import React from 'react';

import { useProductPersonalisedText } from '@hooks/directusHooks/useProductPersonalisedText';
import HowItWorks from '@components/how-it-works';
import PersonalisedVitamins from '@components/personalised-vitamins';
import ExpertApproval from '@components/expert-approval';
import Reviews from '@components/reviews/reviews';
import WhyChooseVitl from '@components/why-choose-vitl/why-choose-vitl';

const PersonalizedPageContent = () => {
  const { directusProductPersonalised, directusHome } = useProductPersonalisedText();

  return (
    <>
      <HowItWorks title={directusProductPersonalised.hiw_title} items={directusProductPersonalised.hiw_items} />

      <PersonalisedVitamins
        title={directusProductPersonalised.personal_title}
        description={directusProductPersonalised.personal_description}
        items={directusProductPersonalised.personal_items}
      />

      <WhyChooseVitl />

      <ExpertApproval
        title={directusHome.expert_approval_title}
        description={directusHome.expert_approval_description}
        experts={directusHome.experts}
        backgroundColor="PrimaryLighter"
      />

      <Reviews title={directusProductPersonalised.reviews_title} items={directusProductPersonalised.reviews_items} hideTrustPilot showReview />
    </>
  );
};

export default PersonalizedPageContent;
